import { useTranslation } from "react-i18next";
import "./styles.css";

export const GeneralDescription = ({ selectedResult, aiValue }) => {
  const { t } = useTranslation(["customAiInfo"]);

  return (
    <p className="result-detail-text">
      {t(
        GeneralInfoAi.includes(selectedResult)
          ? selectedResult.toLowerCase().split(" ").join("-") + "-info"
          : ResultBasedInfoAi.includes(selectedResult)
            ? selectedResult.toLowerCase().split(" ").join("-") +
              "-" +
              aiValue.toLowerCase().split(" ").join("-") +
              "-info"
            : aiValue.toLowerCase().split(" ").join("-") + "-info",
      )}
    </p>
  );
};

const GeneralInfoAi = [
  "Skin Age",
  "Puffy Eyes",
  "Discoloration Eyes",
  "Hair Color",
  "Hair Texture",
  "Hair Color v2",
  "Hair Length",
  "Receding Hair Line",
  "Hair Loss",
  "Eyebrow Density",
  "Lip Natural Color",
  "Skin Tone",
  "Skin Pores",
];

const ResultBasedInfoAi = [
  "Hair Texture v2",
  "Hair Texture v3",
  "Hair Volume",
  "Lip Condition",
  "Skin Acne",
];
